import { useState } from 'react';
// @mui
import { useTheme } from '@mui/material/styles';
import { TableRow, TableCell, MenuItem } from '@mui/material';
// components

import useLocales from 'src/hooks/useLocales';

import PermissionBasedGuard from 'src/guards/PermissionBasedGuard';
import Iconify from 'src/components/Iconify';
import { TableMoreMenu } from 'src/components/table';
import { IElectricMeter } from 'src/@types/Choqorak/Settings/ElectricMeter';
import Label from 'src/components/Label';
// ----------------------------------------------------------------------

type Props = {
  row: IElectricMeter;
  // selected: boolean;
  onEditRow: VoidFunction;
  //onSelectRow: VoidFunction;
  onDeleteRow: VoidFunction;
  handleDetail: VoidFunction;
  handleConsumption: VoidFunction;

  index: any;
};

export default function ElectricMeterTableRow({
  row,
  onEditRow,
  handleDetail,
  onDeleteRow,
  handleConsumption,
  index,
}: Props) {
  const { electricMeterSerial, lastElectricMeterDegree, customerName, shopCode, hasPamentRecord } =
    row;
  const { translate } = useLocales();
  const [openMenu, setOpenMenuActions] = useState<HTMLElement | null>(null);

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setOpenMenuActions(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpenMenuActions(null);
  };

  return (
    <TableRow hover>
      <TableCell align="left">{index + 1}</TableCell>
      <TableCell align="left">{electricMeterSerial}</TableCell>
      <TableCell align="left">{shopCode}</TableCell>
      <TableCell align="left">{customerName}</TableCell>
      {/* <TableCell align="left">{lastElectricMeterDegree}</TableCell>
      <TableCell align="left">{hasPamentRecord?
  (<Label color='success'>{translate('ElectricMeter.Checked')}</Label>)
      :(<Label color='error'>{translate('ElectricMeter.UnChecked')}</Label>)}</TableCell> */}

      <TableCell align="left">
        <TableMoreMenu
          open={openMenu}
          onOpen={handleOpenMenu}
          onClose={handleCloseMenu}
          actions={
            <>
              <PermissionBasedGuard permissions={['ElectricMeter-Delete']}>
                <MenuItem
                  onClick={() => {
                    onDeleteRow();
                    handleCloseMenu();
                  }}
                  sx={{ color: 'error.main' }}
                >
                  <Iconify icon={'eva:trash-2-outline'} />
                  {translate('CRUD.Delete')}
                </MenuItem>
              </PermissionBasedGuard>
              <PermissionBasedGuard permissions={['ElectricMeter-Update']}>
                <MenuItem
                  onClick={() => {
                    onEditRow();
                    handleCloseMenu();
                  }}
                >
                  <Iconify sx={{ color: 'warning.main' }} icon={'eva:edit-fill'} />
                  {translate('CRUD.Update')}
                </MenuItem>
              </PermissionBasedGuard>

              {/* <PermissionBasedGuard permissions={['ElectricityPayment-Create']}>
                <MenuItem
                  onClick={() => {
                    handleConsumption();
                    handleCloseMenu();
                  }}
                >
                  <Iconify sx={{ color: 'info.main' }} icon={'mdi:chart-donut'} />
                  {translate('ElectricMeter.Consumption')}
                </MenuItem>
              </PermissionBasedGuard> */}
              <PermissionBasedGuard permissions={['ElectricMeter-GetDetail']}>
                <MenuItem
                  onClick={() => {
                    handleDetail();
                    handleCloseMenu();
                  }}
                >
                  <Iconify sx={{ color: 'info.main' }} icon={'mdi:account-details'} />
                  {translate('Employee.Details')}
                </MenuItem>
              </PermissionBasedGuard>
            </>
          }
        />
      </TableCell>
    </TableRow>
  );
}
